module.exports = __webpack_public_path__ + "img/about_logo_09.f1f5c3c4.png";